import script from "./HorarioVisitas.vue?vue&type=script&setup=true&lang=js"
export * from "./HorarioVisitas.vue?vue&type=script&setup=true&lang=js"

import "./HorarioVisitas.vue?vue&type=style&index=0&id=802c2d32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-802c2d32"]])

export default __exports__